import { makeHook } from "../../utils/makeSingleArgHook";
import { getResourcePermission, getResourcePermissionURL, } from "../requests/getResourcePermission";
export const GetResourcePermissionMasterCacheKey = "getResourcePermission";
// Due to the recursive/viral nature of the url we need a way to invalidate the cache completely
export const useGetResourcePermissionKeyMaker = (params) => [
    GetResourcePermissionMasterCacheKey, // This is the key that will invalidate the entire cache
    params.resourceType,
    params.resourceId,
    params.permission,
    JSON.stringify(params.query ?? ""),
    getResourcePermissionURL(params),
];
const useGetResourcePermission = makeHook(async (params, config) => getResourcePermission(params, config), useGetResourcePermissionKeyMaker);
export default useGetResourcePermission;
//# sourceMappingURL=useGetResourcePermission.js.map